import { AlertIcon } from '@dynamika-shared/ui/icons';

export type FileValidationError = 'format' | 'size' | 'limit';

export const FileError = ({ type }: { type: FileValidationError }) => {
  const messages: Record<FileValidationError, string> = {
    size: 'Each file must not exceed 50 MB',
    format: 'Please select a ZIP, XLSX, or PDF file',
    limit: 'You can upload a maximum of 20 files at once',
  };

  return (
    <div className="mb-2 w-full rounded-2xl border-[1px] border-redOrange bg-seashell px-2 py-1.5">
      <p className="flex items-center">
        <AlertIcon className="mr-1 h-2 w-2 text-redOrange" /> {messages[type]}
      </p>
    </div>
  );
};
